exports = module.exports = require("../../css-loader/lib/css-base.js")();
exports.push([module.id, ".tribute-container .menu-highlighted,.tribute-container li span{font-weight:700}.tribute-container{position:absolute;top:0;left:0;height:auto;max-height:300px;max-width:500px;overflow:auto;display:block;z-index:999999}.tribute-container ul{margin:2px 0 0;padding:0;list-style:none;background:#efefef}.tribute-container li{padding:5px;cursor:pointer}.tribute-container li.highlight,.tribute-container li:hover{background:#ddd}.tribute-container li.no-match{cursor:default}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/tributejs/dist/tribute.css
// module id = 383
// module chunks = 0